import React from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import restClient, { httpClient } from '../restClient';
import CountCard from '../common/CountCard';
import Typography from '@material-ui/core/Typography';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import LaunchIcon from '@material-ui/icons/Launch';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import BarChart from '../users/BarChart';
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
  icon: { width: '20px', paddingLeft: 6 },
  spacing: { paddingTop: '10px', textAlign: 'right' },
  button: { margin: '12px', background: 'none' },
  linearProgress: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    opacity: 0.4,
    borderRadius: 4
  },
  timeoutMessage: {
    width: '100%',
    height: '100%',
    opacity: 0.4,
    fontSize: '10px',
    textAlign: 'center'
  }
};
const client = restClient(httpClient);
const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 580,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9'
  }
}))(Tooltip);
class Header extends React.Component {
  constructor(props) {
    super(props);
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  state = {
    totalGames: 0,
    totalExercises: 0,
    totalPlayedGames: 0,
    totalActiveUsers: 0,
    totalTeams: 0,
    totalImportedGames: 0,
    totalSponsoredGames: 0,
    totalFromScratchGames: 0,
    expanded: false,
    loading: true
  };

  getSummary() {
    const { resource, queryParams } = this.props;

    client('GET_LIST_SUMMARY', resource, queryParams).then(response =>
      this.setState({
        totalPlayedGames: response.data.total_played_games,
        totalActiveUsers: response.data.total_active_users
      })
    );
  }

  getSummary2() {
    const { resource, queryParams } = this.props;
    client('GET_LIST_SUMMARY2', resource, queryParams).then(response =>
      this.setState({
        totalGames: response.data.total_games,
        totalTeams: response.data.total_teams,
        totalExercises: response.data.total_exercises,
        totalImportedGames: response.data.total_imported_games,
        totalSponsoredGames: response.data.total_sponsored_games,
        totalTemplateGames: response.data.total_template_games,
        totalSharedByColleague: response.data.total_shared_by_colleague,
        totalFromScratchGames: response.data.total_from_scratch_games
      })
    );
  }

  setLoading() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 64000);
  }

  componentDidMount() {
    this.getSummary();
    this.getSummary2();
    this.setLoading();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.queryParams.filter !== this.props.queryParams.filter) {
      this.getSummary();
      this.getSummary2();
    }
  }

  handleExpandClick() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    var self = this;
    var r = {
      number_of_games_created: self.state.totalGames,
      number_of_games_created_by_import: self.state.totalImportedGames,
      number_of_games_created_by_sponsor: self.state.totalSponsoredGames,
      number_of_games_created_by_template: self.state.totalTemplateGames,
      number_of_games_shared_by_colleague: self.state.totalSharedByColleague
    };
    let linearProgressBar = (
      <LinearProgress color="secondary" className={styles.linearProgress} />
    );

    return (
      <Grid
        container
        spacing={16}
        alignItems="flex-start"
        direction="row"
        justify="flex-start"
      >
        <input type="hidden" id="u_total_users" value={this.props.totalUsers} />
        <input
          type="hidden"
          id="u_total_active_users"
          value={this.state.totalActiveUsers}
        />
        <input type="hidden" id="u_total_games" value={this.state.totalGames} />
        <input
          type="hidden"
          id="u_total_played_games"
          value={this.state.totalPlayedGames}
        />
        <input
          type="hidden"
          id="u_total_exerciese"
          value={this.state.totalExercises}
        />
        <input type="hidden" id="u_total_teams" value={this.state.totalTeams} />

        {/* Summary numbers below */}
        {/* Users count */}
        <Grid key="Users" item>
          <CountCard title="Users" value={this.props.totalUsers} />
          {this.state.totalUsers == 0 && (
            <div>
              <ProgressButton title={'Users'} />
              {this.state.loading && linearProgressBar}
              {!this.state.loading && <TimeOutShow />}
            </div>
          )}
        </Grid>

        {/* Active Users */}
        <Grid key="Active Users" item>
          {this.state.totalActiveUsers > 0 && (
            <CountCard
              title="Active Users"
              value={this.state.totalActiveUsers}
            />
          )}

          {this.state.totalActiveUsers == 0 &&
            this.state.loading && (
              <div>
                <ProgressButton title={'Active Users'} />
                {this.state.loading && linearProgressBar}
                {!this.state.loading && <TimeOutShow />}
              </div>
            )}
        </Grid>

        {/* Games count */}
        <Grid key="Games" item>
          {this.state.totalGames > 0 && (
            <Card>
              <CardContent>
                <Typography variant="h1" component="h3">
                  Games
                </Typography>
                <Typography variant="body2" color="gray">
                  total
                </Typography>
                <Typography>
                  <HtmlTooltip
                    title={
                      <React.Fragment>
                        <div style={styles.spacing}>
                          <Typography
                            variant="body2"
                            component="p"
                            color="inherit"
                          >
                            Total
                          </Typography>
                          <Typography variant="h1" component="h1" gutterBottom>
                            {this.state.totalGames}
                          </Typography>
                        </div>
                        <BarChart record={r} />
                        <Typography variant="h2" component="h3" color="inherit">
                          {'Created Games detailed chart'}
                        </Typography>
                        <em>
                          {
                            'Note: Shared by colleague might have been counted in other figures'
                          }
                        </em>{' '}
                      </React.Fragment>
                    }
                  >
                    <Button>
                      <Typography variant="h2" component="h2" gutterBottom>
                        {this.state.totalGames}
                      </Typography>
                      <LaunchIcon style={styles.icon} />
                    </Button>
                  </HtmlTooltip>
                </Typography>
              </CardContent>
            </Card>
          )}

          {this.state.totalGames == 0 && (
            <div>
              <ProgressButton title={'Games'} />
              {this.state.loading && linearProgressBar}
              {!this.state.loading && <TimeOutShow />}
            </div>
          )}
        </Grid>

        {/* Playerd Games count */}
        <Grid key="Played Games" item>
          {this.state.totalPlayedGames > 0 && (
            <CountCard
              title="Played Games"
              value={this.state.totalPlayedGames}
            />
          )}
          {this.state.totalActiveUsers == 0 && (
            <div>
              <ProgressButton title={'Played Games'} />
              {this.state.loading && linearProgressBar}
              {!this.state.loading && <TimeOutShow />}
            </div>
          )}
        </Grid>

        {/* Exercises count */}
        <Grid key="Exercises" item>
          {this.state.totalExercises > 0 && (
            <CountCard title="Exercises" value={this.state.totalExercises} />
          )}
          {this.state.totalExercises == 0 && (
            <div>
              <ProgressButton title={'Exercises'} />
              {this.state.loading && linearProgressBar}
              {!this.state.loading && <TimeOutShow />}
            </div>
          )}
        </Grid>

        {/* Teams count */}
        <Grid key="Teams" item>
          {this.state.totalTeams > 0 && (
            <CountCard title="Teams" value={this.state.totalTeams} />
          )}
          {this.state.totalTeams == 0 && (
            <div>
              <ProgressButton title={'Teams'} />
              {this.state.loading && linearProgressBar}
              {!this.state.loading && <TimeOutShow />}
            </div>
          )}
        </Grid>
      </Grid>
    );
  }
}

const ProgressButton = ({ title }) => (
  <Button
    variant="contained"
    color="primary"
    style={styles.button}
    disabled={true}
  >
    {' '}
    {title}
  </Button>
);

const TimeOutShow = () => (
  <div color="primary" style={styles.timeoutMessage}>
    {' '}
    <SentimentDissatisfiedIcon />
  </div>
);
function mapStateToProps(state, props) {
  const resourceState = state.admin.resources[props.resource];
  return {
    queryParams: resourceState.list.params,
    totalUsers: resourceState.list.total
  };
}
export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/users/Header.js